import type { QueryClient } from '@tanstack/react-query'

/** Prefix keys — invalidating one clears every page and filter combination for that workflow. */
export const salesOrderListQueryKeys = {
  awaitingValidation: (workflowId: string) =>
    ['sales-order-awaiting-validation', workflowId] as const,
  done: (workflowId: string) => ['sales-order-done', workflowId] as const,
  counts: (workflowId: string) => ['sales-order-counts', workflowId] as const,
}

export const salesOrderDetailQueryKeys = {
  inbox: (workflowId: string) => ['sales-order-inbox', workflowId] as const,
  inboxEmail: (workflowId: string, emailId: string) =>
    ['sales-order-inbox-email', workflowId, emailId] as const,
  customerOrder: (customerOrderId: string) =>
    ['customer-order-detail', customerOrderId] as const,
}

/** Matches the order confirmation side: serve the cache instantly, refetch in the background. */
export const salesOrderQueryOptions = {
  staleTime: 0,
} as const

export function invalidateSalesOrderData(
  queryClient: QueryClient,
  workflowId: string | undefined,
): void {
  if (!workflowId) return
  void queryClient.invalidateQueries({
    queryKey: salesOrderListQueryKeys.awaitingValidation(workflowId),
  })
  void queryClient.invalidateQueries({ queryKey: salesOrderListQueryKeys.done(workflowId) })
  void queryClient.invalidateQueries({ queryKey: salesOrderListQueryKeys.counts(workflowId) })
  void queryClient.invalidateQueries({ queryKey: salesOrderDetailQueryKeys.inbox(workflowId) })
  void queryClient.invalidateQueries({ queryKey: ['workflow-summaries'] })
}
